import { QrScanner } from '@yudiel/react-qr-scanner'
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { QRInput } from './QRInput'

type Props = {
  flowName?: string
}

export const QRScanner = ({ flowName }: Props) => {
  const [startScan, setStartScan] = useState(true)
  const dispatch = useDispatch()

  const handleScan = useCallback(
    (id: string) => {
      if (id && flowName) {
        dispatch({ type: 'orders/scanQrOrderSaga', payload: { flowName, id } })
        setStartScan(false)
      }
    },
    [dispatch, flowName]
  )

  const handleError = useCallback((err: Error) => {
    console.error(err)
  }, [])

  return startScan ? (
    <>
      <QrScanner
        scanDelay={100}
        onError={handleError}
        onDecode={handleScan}
        containerStyle={{ width: 300, height: 300, paddingTop: '0%' }}
        videoStyle={{ width: 300, height: 300 }}
      />

      {process.env.NODE_ENV === 'development' && <QRInput handleScan={handleScan} />}
    </>
  ) : (
    <></>
  )
}
